<template>
  <div>
    <div v-if="showType == 'properties'">
      <eoc-vitals-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size:14px;"
      v-else-if="showType != 'form-submitter' || (showType == 'form-submitter' && page == currentPage)"
      :description="computedPropertiesForm.description"
      :label="computedPropertiesForm.label"
      :style="properties.style"
    >
      <b-table
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
    </b-form-group>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { formatDate } from "../../../../helpers/date";
import EocVitalsV1Properties from "./EocVitalsV1Properties.vue";
import vitalRecordServer from "../../../../server/vitalRecord";
export default {
  name: "EocVitalsV1",
  components: { EocVitalsV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["description", "label"],
      computedConditions: {},
      vitalRecords: null
    };
  },
  async mounted() {
      if (this.showType != "form-builder" && !this.vitalRecords) {
        const vitals = await vitalRecordServer.query(
          false,
          this.client.episodeOfCare.id
        );
        this.vitalRecords = vitals.map(vital => {
          let vitalItems = "";
          for (let index = 0; index < vital.items.length; index++) {
            const item = vital.items[index];
            vitalItems += `${item.vitalSign.name}: ${item.value}\n`;
          }
          return {
            dateTime: formatDate(vital.dateTime),
            user: vital.user ? this.formatUser(vital.user) : "",
            items: vitalItems
          };
        });
      }

      this.computeConditions();
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:14px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="3" class="table b-table custom-fb-table mt-2 table-striped table-responsive table-hover" id="__BVID__50">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div style="font-size:14px;">Date</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div style="font-size:14px;">Creator</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3">
                      <div style="font-size:14px;">Vitals</div>
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    item => `
                  <tr role="row" class="">
                    <td style="font-size:14px;" aria-colindex="1" role="cell" class="">${item.dateTime}</td>
                    <td style="font-size:14px;" aria-colindex="2" role="cell" class="">${item.user}</td>
                    <td style="font-size:14px;" aria-colindex="3" class="pre-wrap" role="cell">${item.items}</td>
                  </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      client: state => state.form.client,
      currentPage: state => state.form.currentPage
    }),

    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    ...mapGetters("client", ["vitalSignsCurrentLocation"]),
    vitalSigns() {
      return this.vitalSignsCurrentLocation.filter(
        vitalSign => vitalSign.status == "Enabled"
      );
    },
    tableProperties() {
      return {
        ...this.properties,
        items: this.vitalRecords ? this.vitalRecords : [],
        columns: [
          {
            key: "dateTime",
            label: "Date"
          },
          {
            key: "user",
            label: "Creator"
          },
          {
            key: "items",
            label: "Vitals",
            class: "pre-wrap"
          }
        ]
      };
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    }
  }
};
</script>
